import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

const getData = async () => {
  const data = await axios.get(
    `https://api.jup.ag/price/v2?ids=So11111111111111111111111111111111111111112&showExtraInfo=true`,
  );
  const price =
    data.data.data.So11111111111111111111111111111111111111112.price;
  return price as number;
};

export default function useExchangeRate() {
  return useQuery({
    queryKey: ['exchange-rate'],
    queryFn: getData,
    staleTime: 1000 * 60,
  });
}
